import { createSlice } from "@reduxjs/toolkit";

export const FetchLatestRecordSlice = createSlice({
    name: "fetchLatestRecord",
    initialState: {
        fetchLatestRecord: false,
    },
    reducers: {
        setFetchLatestRecordStatus: (state, action) => {
            state.fetchLatestRecord = action.payload;
        }
    }
})

export const { setFetchLatestRecordStatus } = FetchLatestRecordSlice.actions;

export default FetchLatestRecordSlice.reducer;